import type { IconData } from '@stacksjs/iconify-core'

export const actionUndo: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M495.473 197.262c0-73.061-43.651-136.118-106.242-164.462q-2-.9-4.021-1.762q-4.046-1.715-8.19-3.235q-2.071-.761-4.167-1.47q-4.19-1.422-8.468-2.64a180.95 180.95 0 0 0-98.675 0q-4.278 1.218-8.469 2.64q-2.094.71-4.166 1.47q-4.143 1.519-8.19 3.235q-2.023.857-4.021 1.762c-62.592 28.344-106.242 91.4-106.242 164.462v237.483L38.627 338.75L16 361.377L150.623 496l134.623-134.623l-22.627-22.627l-96 96V197.263c0-72.891 52.814-133.678 122.186-146.1a149.4 149.4 0 0 1 52.479 0c69.371 12.426 122.186 73.213 122.186 146.1h32Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default actionUndo
